import { render, staticRenderFns } from "./ServicesSmall.vue?vue&type=template&id=55129b6b&"
import script from "./ServicesSmall.vue?vue&type=script&lang=js&"
export * from "./ServicesSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports